import React from 'react'
import { FaFacebook, FaLinkedin, FaInstagram, FaTwitter } from 'react-icons/fa'


const HeaderSocials = () => {
    return (

        <div className='social'>

            <a href="https://www.linkedin.com/in/john-paul-salazar-224659193/" target='_blank' rel='noopener noreferrer'>
                <FaLinkedin size={20} />
            </a>

            <a href="https://www.facebook.com/johnpaul.d.salazar" target='_blank' rel='noopener noreferrer'>
                <FaFacebook size={20} />
            </a>

            <a href="https://www.instagram.com/jpaul.salazar/" target='_blank' rel='noopener noreferrer'>
                <FaInstagram size={20} />
            </a>

            {/* <a href="https://twitter.com/pauldsalazar" target='_blank' rel='noopener noreferrer'>
                <FaTwitter size={20} />
            </a> */}


        </div>

    )
}

export default HeaderSocials